var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L10 3H11V7H9V4Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 3H13.9995L14.9995 4V7H12.9995V3Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 18.999H13.0005V21.999H11.0005V18.999Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99951 8.00098L6.99951 10.001V13.001C6.99951 10.2396 9.23809 8.00098 11.9995 8.00098C14.7609 8.00098 16.9995 10.2396 16.9995 13.001V10.001L14.9995 8.00098H11.9995H8.99951Z",
    fill: "#3360AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 16.001C13.6564 16.001 14.9995 14.6578 14.9995 13.001C14.9995 11.3441 13.6564 10.001 11.9995 10.001C10.3427 10.001 8.99951 11.3441 8.99951 13.001C8.99951 14.6578 10.3427 16.001 11.9995 16.001ZM11.9995 18.001C14.7609 18.001 16.9995 15.7624 16.9995 13.001C16.9995 10.2396 14.7609 8.00098 11.9995 8.00098C9.23809 8.00098 6.99951 10.2396 6.99951 13.001C6.99951 15.7624 9.23809 18.001 11.9995 18.001Z",
    fill: "#3360AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 11.001H13.0005V15.001H11.0005V11.001Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.3cce9951cdda47aebb062fb1fd8b17ea.svg";
export { ForwardRef as ReactComponent };